var a = /* @__PURE__ */ ((r) => (r.DEFAULT = "default", r.SMALL = "small", r))(a || {});
export {
  a as RocheUISelectSize
};
